module.exports = __webpack_public_path__ + "img/icon69.2e59ee92.png";